export default {
  SET_USERS: 'SET_USERS',
  SET_ROLES: 'SET_ROLES',
  SET_LOGIN_ERROR: 'SET_LOGIN_ERROR'
}
